import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { WithChildren } from 'types/app';
export function WithConnection({ children }: WithChildren) {
  const history = useHistory();
  // useEffect(() => {
  //   if (!window.ethereum) {
  //     alert('You must install meta mask first');
  //     history.push('/connect');
  //   }
  // }, []);
  return children;
}
